import { createAction, props, union } from '@ngrx/store';

export const selectTruck = createAction('[BatchReportFilter] SELECT_TRUCK',
props<{ truckId: number }>());

export const selectMixDesign = createAction('[BatchReportFilter] SELECT_MIX_DESIGN',
props<{ mixDesignId: number }>());

export const selectJob = createAction('[BatchReportFilter] SELECT_JOB',
props<{ jobId: number }>());

export const selectCustomer = createAction('[BatchReportFilter] SELECT_CUSTOMER',
props<{ customerId: number}>());

export const SetFilterFormExpanded = createAction('[BatchReportFilter] SET_FILTER_FORM_EXPANDED', props<{ expanded: boolean }>());

export const BatchReportFilterActions = union({
  selectTruck, selectMixDesign, selectJob, selectCustomer, SetFilterFormExpanded,
});
